// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DGZG","textarea":"styles_textarea__3yNng"};